export const BagArt = ({ f, className = "", testid }) => {
  if (f.img) {
    return <img src={f.img} alt={`${f.name} bag`} loading="lazy" data-testid={testid}
      className={`object-contain drop-shadow-[0_24px_30px_rgba(27,21,48,0.28)] ${className}`} />;
  }
  return (
    <div data-testid={testid} className={`relative aspect-[3/4] rounded-[26px] rounded-t-[34px] shadow-[0_24px_30px_rgba(27,21,48,0.25)] overflow-hidden ${className}`}
      style={{ background: `linear-gradient(160deg, ${f.color}, ${f.color}cc)` }}>
      <div className="absolute inset-x-0 top-3 h-2 mx-4 rounded-full bg-white/30" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 text-white">
        <img src="/img/logo.webp" alt="" className="w-[78%] drop-shadow" />
        <p className="font-display text-2xl sm:text-3xl leading-none mt-3">{f.name}</p>
        <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.2em] opacity-90">22g protein · 70g</p>
      </div>
    </div>
  );
};
